export function getROC(player,gmaeTurn=0,event=null){
    const d =player?.turns?.[gmaeTurn]
    var sum = 0
    sum += d?.premium_income;
    for(let i of ['governtment_bond','investment_grade_bond','high_yield_bond','listed_equity','property','cash'])
       sum += d?.assets?.invested_assets?.amount * d?.assets?.invested_assets?.[i]?.allocation*d?.assets?.invested_assets?.[i]?.annual_return_assumption
    sum += d?.claims_and_benefit||0;
    sum +=d?.operating_expense||0;
    sum += -d?.liabilities?.policy_reserves?.amount * 0.04
    sum += d?.new_business_investment?.sales_force?.amount *  d?.new_business_investment?.sales_force?.return
    
    if(event){
        const a =((getTotalAssets(player,gmaeTurn)-getTotalLiabilities(player,gmaeTurn)-getNewBusinessInvestment(player,gmaeTurn)))
        const b=(getTotalAssets(player,gmaeTurn,event)-getTotalLiabilities(player,gmaeTurn,event)-getNewBusinessInvestment(player,gmaeTurn,event))
        const delta= (-a+b+ d?.new_business_investment?.sales_force?.amount * d?.new_business_investment?.sales_force?.return * event?.return_from_nb) + (d?.claims_and_benefit * event?.claims_and_benefit)

        return sum + delta
    }
    
    return sum;
}

export function getAssetDollarDuration(player,turn,event=null){
    var sum = 0
    if(event){
        return L3(player,turn,event)+L4(player,turn,event)+L5(player,turn,event)
    }
    const invested_assets=player?.turns?.[turn]?.assets?.invested_assets
    sum+= invested_assets?.amount * invested_assets?.governtment_bond?.allocation * invested_assets?.governtment_bond?.average_duration
    sum+= invested_assets?.amount * invested_assets?.investment_grade_bond?.allocation * invested_assets?.investment_grade_bond?.average_duration
    sum+= invested_assets?.amount * invested_assets?.high_yield_bond?.allocation * invested_assets?.high_yield_bond?.average_duration
    return sum
}
export function getLiabilityDollarDuration(player,turn,event=null){
    var sum = 0
    const liabilities= player?.turns?.[turn]?.liabilities
    if(event){
        const H10 =-( event?.governtment_bond + event?.investment_grade_bond* 0.5 * player?.turns?.[turn]?.assets?.invested_assets?.investment_grade_bond?.allocation) * liabilities?.policy_reserves?.amount * liabilities?.policy_reserves?.average_duration 
        return (liabilities?.policy_reserves?.amount + H10) * liabilities?.policy_reserves?.average_duration 
    }
    sum+= liabilities?.policy_reserves?.amount * liabilities?.policy_reserves?.average_duration 
    return sum
}

export function getEquityRiskCharge(player,turn,event=null){
    return getEquityRiskExposure(player,turn,event) * 0.4
}
export function getEquityRiskExposure(player,turn,event=null){
    const invested_assets=player?.turns?.[turn]?.assets?.invested_assets
    if(event){
        let a =(invested_assets?.amount * invested_assets?.listed_equity?.allocation)
        return(a * (1+event?.listed_equity))
    }
    return invested_assets?.listed_equity?.allocation * invested_assets?.amount 
}
export function getPropertyRiskCharge(player,turn,event=null){
    return getPropertyRiskExposure(player,turn,event) * 0.25
}
export function getPropertyRiskExposure(player,turn,event=null){
    const invested_assets=player?.turns?.[turn]?.assets?.invested_assets
    if(event){
        let a =(invested_assets?.amount * invested_assets?.property?.allocation)
        return(a * (1+event?.property))
    }
    return invested_assets?.property?.allocation * invested_assets?.amount 
}
function L3(player,turn,event){
    const invested_assets=player?.turns?.[turn]?.assets?.invested_assets
    let a =invested_assets?.amount * invested_assets?.governtment_bond?.allocation * invested_assets?.governtment_bond?.average_duration
    const b = a * event?.governtment_bond
    return(invested_assets?.amount * invested_assets?.governtment_bond?.allocation - b) *invested_assets?.governtment_bond?.average_duration
}
function L4(player,turn,event){
    const invested_assets=player?.turns?.[turn]?.assets?.invested_assets
    let a =invested_assets?.amount * invested_assets?.investment_grade_bond?.allocation * invested_assets?.investment_grade_bond?.average_duration
    const b = a * event?.investment_grade_bond
    return(invested_assets?.amount * invested_assets?.investment_grade_bond?.allocation - b) *invested_assets?.investment_grade_bond?.average_duration
}
function L5(player,turn,event){
    const invested_assets=player?.turns?.[turn]?.assets?.invested_assets
    let a =invested_assets?.amount * invested_assets?.high_yield_bond?.allocation * invested_assets?.high_yield_bond?.average_duration
    const b = a * event?.high_yield_bond
    return a+b
}
export function getInterestRateRiskCharge(player,turn,event=null){
    return getInterestRateRiskExposure(player,turn,event)*0.02
}
export function getInterestRateRiskExposure(player,turn,event=null){
    const liabilities=player?.turns?.[turn]?.liabilities
    const invested_assets=player?.turns?.[turn]?.assets?.invested_assets
    if(event){
        let a =(liabilities?.policy_reserves?.amount)
        const percent =  (event?.governtment_bond||0) + (event?.investment_grade_bond||0) * 0.5 *  (invested_assets.investment_grade_bond?.allocation||0) 
        const b = a*(percent)*(liabilities?.policy_reserves?.average_duration)
        const total = (a-b) *(liabilities?.policy_reserves?.average_duration)
        const sum = Math.abs(L3(player,turn,event) + L4(player,turn,event) + L5(player,turn,event) - total)
        return sum
    }
    const total = invested_assets?.governtment_bond?.allocation*invested_assets?.governtment_bond?.average_duration
                +invested_assets?.investment_grade_bond?.allocation*invested_assets?.investment_grade_bond?.average_duration
                +invested_assets?.high_yield_bond?.allocation*invested_assets?.high_yield_bond?.average_duration
    const assetDollarDuration=total*(invested_assets?.amount||0);
    const liabilitiesDollarDuration = liabilities?.policy_reserves?.amount*liabilities?.policy_reserves?.average_duration
    return Math.abs(assetDollarDuration-liabilitiesDollarDuration)
}
export function getCreditSpreadRiskCharge(player,turn,event=null){
    if(event){
        return L4(player,turn,event)*0.015+ L5(player,turn,event)*0.04
    }
    const invested_assets=player?.turns?.[turn]?.assets?.invested_assets
    const IGB =invested_assets?.investment_grade_bond?.average_duration * invested_assets?.investment_grade_bond?.allocation * invested_assets?.amount
    const HYB =invested_assets?.high_yield_bond?.average_duration * invested_assets?.high_yield_bond?.allocation * invested_assets?.amount
    return IGB * 0.015 + HYB * 0.04
}

export function getCreditSpreadRiskExposure(player,turn,event=null){
    if(event){
        return L4(player,turn,event)+ L5(player,turn,event)
    }
    const invested_assets=player?.turns?.[turn]?.assets?.invested_assets
    const IGB =invested_assets?.investment_grade_bond?.average_duration * invested_assets?.investment_grade_bond?.allocation * invested_assets?.amount
    const HYB =invested_assets?.high_yield_bond?.average_duration * invested_assets?.high_yield_bond?.allocation * invested_assets?.amount
    return IGB  + HYB 
}


export function getNewBusinessInvestment(player,turn,event=null){
    var sum=0
    if(!player?.turns?.[turn])return sum
    for(let i in player?.turns?.[turn]?.new_business_investment){
        sum+= player?.turns?.[turn]?.new_business_investment?.[i]?.amount||0
    }
    return sum
}
export function getInsuranceRisk(player,turn,event=null){
    return 745
}
export function getgeneralInsuranceRisk(player,turn,event=null){
    return 500 * 0.01
}
export function getcounterPartyDefaultRisk(player,turn,event=null){
    return 800*0.05
}
export function getoperationalRisk(player,turn,event=null){
    return 1000 * 0.01;
}


export function getPCR(player,turn,event=null){
    const marketRisk=getMarketRisk(player,turn,event)
    const insuranceRisk =getInsuranceRisk(player,turn,event)
    const generalInsuranceRisk = getgeneralInsuranceRisk(player,turn,event)
    const counterPartyDefaultRisk = getcounterPartyDefaultRisk(player,turn,event)
    const operationalRisk= getoperationalRisk(player,turn,event)
    const matrix= [
        [1,.25,.25,.25],
        [.25,1,0,.25],
        [.25,0,1,.25],
        [.25,.25,.25,1],
    ]

    const m1 = marketRisk * matrix[0][0] 
                    + insuranceRisk * matrix[1][0] 
                    + generalInsuranceRisk * matrix[2][0]
                    + counterPartyDefaultRisk * matrix[3][0]
    const m2 = marketRisk * matrix[0][1] 
                    + insuranceRisk * matrix[1][1] 
                    + generalInsuranceRisk * matrix[2][1]
                    + counterPartyDefaultRisk * matrix[3][1]
    const m3 = marketRisk * matrix[0][2] 
                    + insuranceRisk * matrix[1][2] 
                    + generalInsuranceRisk * matrix[2][2]
                    + counterPartyDefaultRisk * matrix[3][2]
    const m4 = marketRisk * matrix[0][3] 
                    + insuranceRisk * matrix[1][3] 
                    + generalInsuranceRisk * matrix[2][3]
                    + counterPartyDefaultRisk * matrix[3][3]

    const result=marketRisk * m1
    + insuranceRisk * m2
    + generalInsuranceRisk * m3
    + counterPartyDefaultRisk * m4

    return Math.sqrt(result)+operationalRisk;
}
export function getCurrencyRiskCharge(player,turn,event=null){
    return getCurrencyRiskExposure(player,turn,event)*0.01
}
export function getCurrencyRiskExposure(player,turn,event=null){
    return 0
}

export function getMarketRisk(player,turn,event=null){
    const a =[
        getInterestRateRiskCharge(player,turn,event),
        getCreditSpreadRiskCharge(player,turn,event),
        getEquityRiskCharge(player,turn,event),
        getPropertyRiskCharge(player,turn,event),
        getCurrencyRiskCharge(player,turn,event)
]
    const matrix= [
        [1,.5,.5,.25,.25],
        [.5,1,.75,.5,.25],
        [.5,.75,1,.5,.25],
        [.25,.5,.5,1,.25],
        [.25,.25,.25,.25,1],
    ]
    const arr=[]
    for(let i =0;i<5;i++){
        let sum = 0
        for(let j =0;j<5;j++)
           sum+=a[j]*matrix[j][i]
        arr[i]=sum
    }
    const result=a[0]*arr[0] + a[1]*arr[1] + a[2]*arr[2] +a[3]*arr[3] + a[4]*arr[4]
    return Math.sqrt(result)
}

export function getTotalAssets_(player,turn,event=null){
    var sum=0
    if(!player?.turns?.[turn])return sum
    const assets = player?.turns?.[turn]?.assets;

    if(event){
        let invested_assets=assets.invested_assets;
        sum +=  (invested_assets?.governtment_bond?.allocation||0) * (invested_assets?.amount||0) * (1 - (event?.governtment_bond||0)*(invested_assets?.governtment_bond?.average_duration||0))
        sum +=  (invested_assets?.investment_grade_bond?.allocation||0) * (invested_assets?.amount||0)* (1 - (event?.investment_grade_bond||0)*(invested_assets?.investment_grade_bond?.average_duration||0))
        sum +=  (invested_assets?.high_yield_bond?.allocation||0) * (invested_assets?.amount||0)* (1 + (event?.high_yield_bond||0))
        sum +=  (invested_assets?.listed_equity?.allocation||0) * (invested_assets?.amount||0)* (1 + (event?.listed_equity||0))
        sum +=  (invested_assets?.property?.allocation||0) * (invested_assets?.amount||0)* (1 + (event?.property||0))
        sum +=  (invested_assets?.cash?.allocation||0) * (invested_assets?.amount||0)* (1 + (event?.cash||0))
    }else{
        sum += assets.invested_assets.amount||0
    }
    sum += assets.non_invested_asset.amount||0
    sum += assets.other_receivables.amount||0
    sum += assets.reinsurance_balance.amount||0
    // for(let i in player?.turns?.[turn]?.assets){
    //     sum+= player?.turns?.[turn]?.assets?.[i]?.amount||0
    // }
    return sum
}
export function getTotalLiabilities(player,turn,event=null){
    var sum=0
    if(!player?.turns?.[turn])return sum
    const liabilities = player?.turns?.[turn]?.liabilities;

    sum += liabilities.policy_reserves.amount||0
    sum += liabilities.margin_over_current_estimate.amount||0
    sum += liabilities.other_liabilities.amount||0
    sum += liabilities.reinsurance_balance.amount||0
    // for(let i in player?.turns?.[turn]?.liabilities){
    //     sum+= player?.turns?.[turn]?.liabilities?.[i]?.amount||0
    // }

    if(event){
        const percent =  (event?.governtment_bond||0) + (event?.investment_grade_bond||0) * 0.5 *  (player?.turns?.[turn]?.assets?.invested_assets?.investment_grade_bond?.allocation||0) 
        return sum - (liabilities.policy_reserves.amount||0) * (liabilities.policy_reserves.average_duration||0) * percent
    }

    return sum
}

export function getSurplus(player,turn,event=null){
    return getTotalAssets(player,turn,event)-getTotalLiabilities(player,turn,event)-getNewBusinessInvestment(player,turn,event)
}

export function numberWithCommas(x) {
    if(x==undefined||x.null) return 0
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}


export function calculateScore(player,currentTurn,data,extraPts=[]){
    let pts=0
    for(let i in player?.turns){
        if(i<currentTurn){
            if(i%2==0){
                let ROC= getROC(player,i)/getPCR(player,i)
                let solvencyRatio = getSurplus(player,i)/getPCR(player,i)
                if(solvencyRatio<1){
                    pts+=0
                }else if(ROC<0.15){
                    pts+=1
                } else if(ROC<0.2){
                    pts+=2
                } else if(ROC>=0.2){
                    pts+=3
                }
            }else{
                let solvencyRatio = getSurplus(player,i,data?.game?.[0]?.turns[i]?.event)/getPCR(player,i,data?.game?.[0]?.turns[i]?.event)
                if(solvencyRatio<1){
                    pts+=0
                } else if(solvencyRatio>=1&&solvencyRatio<1.2){
                    pts+=1
                } else if(solvencyRatio>=1.2&&solvencyRatio<1.5){
                    pts+=2
                } else if(solvencyRatio>=1.5){
                    pts+=3
                } 
            }
        }else if(i==currentTurn){
            if(i%2==0&&player?.turns[i].status==='complete'){
                let ROC= getROC(player,i)/getPCR(player,i)
                let solvencyRatio = getSurplus(player,i)/getPCR(player,i)
                if(solvencyRatio<1){
                    pts+=0
                }else if(ROC<0.15){
                    pts+=1
                } else if(ROC<0.2){
                    pts+=2
                } else if(ROC>=0.2){
                    pts+=3
                }
            }else if(data?.game?.[0]?.turns[i]?.event){
                let solvencyRatio = getSurplus(player,i,data?.game?.[0]?.turns[i]?.event)/getPCR(player,i,data?.game?.[0]?.turns[i]?.event)
                if(solvencyRatio<1){
                    pts+=0
                } else if(solvencyRatio>=1&&solvencyRatio<1.2){
                    pts+=1
                } else if(solvencyRatio>=1.2&&solvencyRatio<1.5){
                    pts+=2
                } else if(solvencyRatio>=1.5){
                    pts+=3
                } 
            }
        }
    }
    for(let i of extraPts){
        pts+=(i||0)
    }
    return pts
}

export function calculateScoreByTurn(player,currentTurn,data,turnIndex,extraPts=[]){
    let pts=0
    let i =  turnIndex

        if(i<currentTurn){
            if(i%2==0){
                let ROC= getROC(player,i)/getPCR(player,i)
                let solvencyRatio = getSurplus(player,i)/getPCR(player,i)
                if(solvencyRatio<1){
                    pts+=0
                }else if(ROC<0.15){
                    pts+=1
                } else if(ROC<0.2){
                    pts+=2
                } else if(ROC>=0.2){
                    pts+=3
                }
            }else{
                let solvencyRatio = getSurplus(player,i,data?.game?.[0]?.turns[i]?.event)/getPCR(player,i,data?.game?.[0]?.turns[i]?.event)
                if(solvencyRatio<1){
                    pts+=0
                } else if(solvencyRatio>=1&&solvencyRatio<1.2){
                    pts+=1
                } else if(solvencyRatio>=1.2&&solvencyRatio<1.5){
                    pts+=2
                } else if(solvencyRatio>=1.5){
                    pts+=3
                } 
            }
        }else if(i==currentTurn){
            if(i%2==0&&player?.turns[i].status==='complete'){
                let ROC= getROC(player,i)/getPCR(player,i)
                let solvencyRatio = getSurplus(player,i)/getPCR(player,i)
                if(solvencyRatio<1){
                    pts+=0
                }else if(ROC<0.15){
                    pts+=1
                } else if(ROC<0.2){
                    pts+=2
                } else if(ROC>=0.2){
                    pts+=3
                }
            }else if(data?.game?.[0]?.turns[i]?.event){
                let solvencyRatio = getSurplus(player,i,data?.game?.[0]?.turns[i]?.event)/getPCR(player,i,data?.game?.[0]?.turns[i]?.event)
                if(solvencyRatio<1){
                    pts+=0
                } else if(solvencyRatio>=1&&solvencyRatio<1.2){
                    pts+=1
                } else if(solvencyRatio>=1.2&&solvencyRatio<1.5){
                    pts+=2
                } else if(solvencyRatio>=1.5){
                    pts+=3
                } 
            }
        
    }

    for(let i of extraPts){
        pts+=(i||0)
    }
    return pts
}






export const getCapital=(player,turn)=>{
    if(!player?.turns?.[turn]) return 0
    let thisTurn = player?.turns?.[turn]
    return Math.round((thisTurn?.capital||0)*100)/100
}
export const getEarning=(player,turn)=>{
    if(!player?.turns?.[turn]) return 0
    let thisTurn = player?.turns?.[turn]
    return Math.round( ((thisTurn.totalAsset*thisTurn.profitMargin*(1+thisTurn.growthRate)*thisTurn.assetGenerateRevunue*(1+thisTurn.debtRatio)) - getInterest(player,turn)  )*100)/100
    //return Math.round((getCapital(player,turn)*thisTurn.profitMargin/(1-thisTurn.profitMargin)*(1+thisTurn.getGrowthRate))*100)/100
}
export const getInterest =(player,turn)=>{
    if(!player?.turns?.[turn]) return []
    let thisTurn = player?.turns?.[turn]
    return thisTurn.totalLiability * thisTurn.interestRate 
}
export const getEarningArray=(player,turn)=>{
    if(!player?.turns?.[turn]) return []
    let thisTurn = player?.turns?.[turn]
    return [...(thisTurn.earningArray||[]),getEarning(player,turn)]
}
export const getAccumulatedEarning=(player,turn)=>{
    if(!player?.turns?.[turn]) return 0
    let thisTurn = player?.turns?.[turn]
    return Math.round((getEarning(player,turn)+ (thisTurn.accumulatedEarning||0))*100)/100
}
export const getTotalAssets=(player,turn)=>{
    if(!player?.turns?.[turn]) return 0
    let thisTurn = player?.turns?.[turn]
    return Math.round((      (thisTurn.totalAsset + getEarning(player,turn) )     )*100)/100
}
export const getLiability=(player,turn)=>{
    if(!player?.turns?.[turn]) return 0
    let thisTurn = player?.turns?.[turn]
    return Math.round(getTotalAssets(player,turn)*thisTurn.debtRatio*100)/100
}
export const getGrowthRate=(player,turn)=>{
    if(!player?.turns?.[turn]) return 0
    let thisTurn = player?.turns?.[turn]
    return Math.round(thisTurn.growthRate*100)/100
}
export const getOperatingValuation=(player,turn)=>{
    if(!player?.turns?.[turn]) return 0
    let thisTurn = player?.turns?.[turn]
    return Math.round((  getEarning(player,turn)*(1+getGrowthRate(player,turn))/(thisTurn.discountRate-getGrowthRate(player,turn))   +getTotalAssets(player,turn)-getLiability(player,turn)   )*100)/100
    //return Math.round(( getNPV(thisTurn.discountRate,0,getEarningArray(player,turn))+getTotalAssets(player,turn)-getLiability(player,turn)+getEarningArray(player,turn)[0]*Math.max(0,1/(1+getGrowthRate(player,turn))/(thisTurn.debtRatio-thisTurn.discountRate)))*100)/100
}
export const getInvestmentValuation=(player,turn)=>{
    if(!player?.turns?.[turn]) return 0
    let thisTurn = player?.turns?.[turn]
    return Math.round(  (thisTurn.investments?.reduce((acc,i)=>i.value+acc,0) + thisTurn.cash )*100)/100
}












// export const getGuarenteeGrowth=(player,turn)=>{
//     if(!player?.turns?.[turn]) return 0
//     let thisTurn = player?.turns?.[turn]
//     return Math.round((  thisTurn.annualPremium * thisTurn.guaranteeMinimumReturn  )*100)/100
// }
// export const getMarketGrowth=(player,turn)=>{
//     if(!player?.turns?.[turn]) return 0
//     let thisTurn = player?.turns?.[turn]
//     return Math.round((  thisTurn.marketReturn * thisTurn.annualPremium  )*100)/100
// }
// export const getGuaranteeCost=(player,turn)=>{
//     if(turn<0||!player?.turns?.[turn]) return 0
//     let thisTurn = player?.turns?.[turn]
//     return Math.round((  Math.max(0, getGuarenteeGrowth(player,turn)-getMarketGrowth(player,turn))  )*100)/100
// }
// export const getCumulativeGuaranteeCost=(player,turn)=>{
//     if(turn<0||!player?.turns?.[turn]) return 0
//     let thisTurn = player?.turns?.[turn]
//     return Math.round(( getGuaranteeCost(player,turn) +  getCumulativeGuaranteeCost(player,turn-2) )*100)/100
// }
// export const getBonus=(player,turn)=>{
//     if(turn<0||!player?.turns?.[turn]) return 0
//     let thisTurn = player?.turns?.[turn]
//     return Math.round((   Math.max(0, getMarketGrowth(player,turn)-getGuarenteeGrowth(player,turn) ) * thisTurn.participationRate  )*100)/100
// }
// export const getCumulativeBonus=(player,turn)=>{
//     if(!player?.turns?.[turn]) return 0
//     let thisTurn = player?.turns?.[turn]
//     return Math.round(( getBonus(player,turn) +  getBonus(player,turn-2) )*100)/100
// }
// export const getTVoG=(player,turn)=>{
//     if(!player?.turns?.[turn]) return 0
//     let thisTurn = player?.turns?.[turn]
//     return Math.round(( getCumulativeGuaranteeCost(player,turn) /thisTurn.policyTerm  )*100)/100
// }
// export const getTotalValue=(player,turn)=>{
//     if(!player?.turns?.[turn]) return 0
//     let thisTurn = player?.turns?.[turn]
//     return Math.round(( getGuaranteeCost(player,turn) +getBonus(player,turn)  )*100)/100
// }
// export const getMarketShare=(player,turn)=>{
//     if(!player?.turns?.[turn]) return 0
//     let thisTurn = player?.turns?.[turn]
//     return Math.round(( getTotalValue(player,turn)/thisTurn.allPlayers  )*10000)/10000
// }
// export const getIncreaseInMarketValue=(player,turn)=>{
//     if(!player?.turns?.[turn]) return 0
//     let thisTurn = player?.turns?.[turn]
//     return Math.round(( thisTurn.marketMultiplier * getMarketShare(player,turn)  )*100)/100
// }
// export const getRiskPenalty=(player,turn)=>{
//     if(!player?.turns?.[turn]) return 0
//     let thisTurn = player?.turns?.[turn]
//     return Math.round(( thisTurn.riskPenaltyFactor * getTVoG(player,turn)  )*100)/100
// }








export const getCompanyValue=(player,turn)=>{
    if(turn<0||!player?.turns?.[turn]){
        if(player?.turns?.[0]) return player?.turns?.[0].initialCapital
        else return 0
    }
    let thisTurn = player?.turns?.[turn]
    return  Math.max(0, getCompanyValue(player,turn-2)+getValueCreationInTheYear(player,turn))
}
export const getValueCreationInTheYear=(player,turn)=>{
    if(!player?.turns?.[turn]) return 0
    let thisTurn = player?.turns?.[turn]
    return getMarketability(player,turn)*(getProfitability(player,turn)-getTVOG(player,turn))
}
export const getMarketability=(player,turn)=>{
    if(!player?.turns?.[turn]) return 0
    let thisTurn = player?.turns?.[turn]
    
    return  (1+thisTurn.guaranteeLevel*thisTurn.guaranteeFactor_) *(1-thisTurn.equityAssetAllocation)*thisTurn.policyTerm/thisTurn.maxPolicyTerm
}
export const getProfitability=(player,turn)=>{
    if(!player?.turns?.[turn]) return 0
    let thisTurn = player?.turns?.[turn]
    return Math.min( ((getReturnInThatYear(player,turn)- thisTurn.guaranteeLevel)*(1-thisTurn.participationRate)) ,(getReturnInThatYear(player,turn)- thisTurn.guaranteeLevel) )*thisTurn.ProfitabilityFactor
}
export const getTVOG=(player,turn)=>{
    if(!player?.turns?.[turn]) return 0
    let thisTurn = player?.turns?.[turn]
    return (getTVOGDownInMil(player,turn)+getTVOGMidInMil(player,turn)+getTVOGUpInMil(player,turn)) /3
}
export const getTVOGDown=(player,turn)=>{
    if(!player?.turns?.[turn]) return 0
    let thisTurn = player?.turns?.[turn]
    return thisTurn.TVOGDown -thisTurn.guaranteeLevel*thisTurn.guaranteeFactor
}
export const getTVOGMid=(player,turn)=>{
    if(!player?.turns?.[turn]) return 0
    let thisTurn = player?.turns?.[turn]
    return thisTurn.TVOGMID -thisTurn.guaranteeLevel*thisTurn.guaranteeFactor
}
export const getTVOGUp=(player,turn)=>{
    if(!player?.turns?.[turn]) return 0
    let thisTurn = player?.turns?.[turn]
    return thisTurn.TVOGUP -thisTurn.guaranteeLevel*thisTurn.guaranteeFactor
}
export const getTVOGDownInMil=(player,turn)=>{
    if(!player?.turns?.[turn]) return 0
    let thisTurn = player?.turns?.[turn]
    return thisTurn.guaranteeLevel * thisTurn.TVOGFactor * (1- getTVOGDown(player,turn)*thisTurn.guaranteeFactor ) * thisTurn.policyTerm/ thisTurn.maxPolicyTerm *(1+thisTurn.equityAssetAllocation)
}
export const getTVOGMidInMil=(player,turn)=>{
    if(!player?.turns?.[turn]) return 0
    let thisTurn = player?.turns?.[turn]
    return thisTurn.guaranteeLevel * thisTurn.TVOGFactor * (1- getTVOGMid(player,turn)*thisTurn.guaranteeFactor ) * thisTurn.policyTerm/ thisTurn.maxPolicyTerm *(1+thisTurn.equityAssetAllocation)
}
export const getTVOGUpInMil=(player,turn)=>{
    if(!player?.turns?.[turn]) return 0
    let thisTurn = player?.turns?.[turn]
    return thisTurn.guaranteeLevel * thisTurn.TVOGFactor * (1- getTVOGUp(player,turn)*thisTurn.guaranteeFactor ) * thisTurn.policyTerm/ thisTurn.maxPolicyTerm *(1+thisTurn.equityAssetAllocation)
}
export const getReturnInThatYear=(player,turn)=>{
    if(!player?.turns?.[turn]) return 0
    let thisTurn = player?.turns?.[turn]
    return thisTurn.equityReturn * thisTurn.equityAssetAllocation + (1- thisTurn.equityAssetAllocation) * thisTurn.bondReturn
}
export const getTargetReturn=(player,turn)=>{
    if(!player?.turns?.[turn]) return 0
    let thisTurn = player?.turns?.[turn]

    return thisTurn.targetEquityReturn * thisTurn.equityAssetAllocation + (1- thisTurn.equityAssetAllocation) * thisTurn.targetBondReturn
}
